function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* script */
//
import ScrollableInkTabBar from './scrollableInkTabBar.js';
import { isVertical } from './utils';
var __vue_script__ = {
  name: 'TabBar',
  components: {
    ScrollableInkTabBar: ScrollableInkTabBar
  },
  props: {
    prefixCls: String,
    tabs: Array,
    tabBarPosition: String,
    size: String,
    extraContent: Array
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls;
      return "".concat(prefixCls, "-bar");
    },
    extraClasses: function extraClasses() {
      var prefixCls = this.prefixCls;
      return "".concat(prefixCls, "-extra-content");
    },
    isLeftOrRight: function isLeftOrRight() {
      var tabBarPosition = this.tabBarPosition;
      return isVertical(tabBarPosition);
    },
    extraStyle: function extraStyle() {
      var isLeftOrRight = this.isLeftOrRight;
      return isLeftOrRight ? null : {
        float: 'right'
      };
    }
  },
  render: function render() {
    var h = arguments[0];

    var classes = this.classes,
        $refs = this.$refs,
        $listeners = this.$listeners,
        _this$$props = this.$props,
        extraContent = _this$$props.extraContent,
        bindProps = _objectWithoutProperties(_this$$props, ["extraContent"]),
        extraClasses = this.extraClasses,
        extraStyle = this.extraStyle,
        isLeftOrRight = this.isLeftOrRight;

    var tabBar = h("scrollable-ink-tab-bar", {
      "attrs": {
        "root-node": $refs.tablistRef
      },
      "props": _objectSpread({}, bindProps),
      "on": _objectSpread({}, $listeners)
    });
    var children = [tabBar];

    if (extraContent) {
      var extra = h("div", {
        "class": extraClasses,
        "style": extraStyle
      }, [extraContent]);

      if (isLeftOrRight) {
        children.push(extra);
      } else {
        children.unshift(extra);
      }
    }

    return h("div", {
      "ref": "tablistRef",
      "attrs": {
        "role": "tablist",
        "tabindex": "0"
      },
      "class": classes
    }, [children]);
  }
};
/* template */

/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "tabBar.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);